import { GrowthBook } from '@growthbook/growthbook-react';

import Config from '@/config';

// Extracted from App.tsx so modules that need `gb` (e.g. util/date.ts) don't
// have to import App itself, which would create an App -> ... -> App cycle.
export const gb = new GrowthBook({
  apiHost: Config.GROWTHBOOK_API_HOST,
  clientKey: Config.GROWTHBOOK_CLIENT_KEY,
});
